import { render, staticRenderFns } from "./ClaimsReport.vue?vue&type=template&id=35cd6a5a&scoped=true"
import script from "./ClaimsReport.vue?vue&type=script&lang=js"
export * from "./ClaimsReport.vue?vue&type=script&lang=js"
import style0 from "./ClaimsReport.vue?vue&type=style&index=0&id=35cd6a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd6a5a",
  null
  
)

export default component.exports